import Cookies from 'js-cookie';
import { PredefinedClient, PredefinedClientName } from "@common/enums/base";
export function isRW() {
    return currentClientId() === PredefinedClient.RentersWarehouse.toString();
}
export function isTRI() {
    return currentClientId() === PredefinedClient.Tricon.toString();
}
export function isWPH() {
    return currentClientId() === PredefinedClient.WPH.toString();
}
export function isIH() {
    return currentClientId() === PredefinedClient.IH.toString();
}
export function isHPA() {
    return currentClientId() === PredefinedClient.HPA.toString();
}
export function isNHR() {
    return currentClientId() === PredefinedClient.NHR.toString();
}
export function isNES() {
    return currentClientId() === PredefinedClient.Nestidd.toString();
}
export function isARK() {
    return currentClientId() === PredefinedClient.ARK.toString();
}
export function isRentredi() {
    return currentClientId() === PredefinedClient.Rentredi.toString();
}
export var currentClientId = function () {
    var clientId = "clientId";
    return Cookies.get(clientId);
};
export var currentClientName = function () {
    var id = currentClientId() ? parseInt(currentClientId(), 10) : PredefinedClient.WPH;
    id = id === PredefinedClient.WPH ? PredefinedClient.IH : id;
    return PredefinedClientName[id];
};
export var currentClientNameById = function (id) {
    return PredefinedClientName[id];
};
export var getClientContact = function () {
    var contact = {
        tel: "xxxxxxxxxx",
        email: ""
    };
    if (isRW()) {
        contact.tel = "8447934948";
    }
    else if (isTRI()) {
        contact.tel = "8556761680";
    }
    else if (isHPA()) {
        contact.tel = "8442958628";
        contact.email = "PathlightMaintenance@SMS-Assist.com";
    }
    else if (isWPH()) {
        contact.tel = "8883304969";
    }
    else if (isIH()) {
        contact.tel = "8883304969";
    }
    else if (isNES()) {
        contact.tel = "4846200980";
    }
    else if (isNHR()) {
        contact.tel = "8666630866";
    }
    else if (isARK()) {
        contact.tel = "8558263860";
    }
    return contact;
};
export var convertPhoneText = function (phone) {
    var str = phone;
    var result = "";
    if (str && str.length === 10) {
        var a = str.substr(0, 3);
        var b = str.substr(3, 3);
        var c = str.substr(6, 4);
        result = "(" + a + ") " + b + "-" + c;
        return result;
    }
    result = str;
    return result;
};
